/* ============================================================
   KYNETIK PASSWORD — interactive billiards-in-space canvas
   - DPR-aware rendering
   - Pointer (mouse + touch) drag-grab a ball
   - Pointer hover/move repels nearby balls
   - Ball-to-ball elastic collisions
   - Wall bounces
   ============================================================ */
(function () {
  'use strict';

  var canvas = document.getElementById('knpCanvas');
  if (!canvas) return;
  var ctx = canvas.getContext('2d');
  if (!ctx) return;

  /* ── Ball palette: classic billiards + neon branded 9-ball ── */
  var PALETTE = [
    { main: '#f2c600', dark: '#7a6500', num: 1,  stripe: false }, /* yellow */
    { main: '#0857b7', dark: '#04295c', num: 2,  stripe: false }, /* blue */
    { main: '#d83535', dark: '#6a1515', num: 3,  stripe: false }, /* red */
    { main: '#6e3fa0', dark: '#341c4c', num: 4,  stripe: false }, /* purple */
    { main: '#ff7c1a', dark: '#7a3a00', num: 5,  stripe: false }, /* orange */
    { main: '#1e7d39', dark: '#0d3a1a', num: 6,  stripe: false }, /* green */
    { main: '#7a1f2b', dark: '#3a0b12', num: 7,  stripe: false }, /* maroon */
    { main: '#151515', dark: '#000000', num: 8,  stripe: false }, /* black 8 */
    { main: '#b9ff00', dark: '#4e6b00', num: 9,  stripe: false }  /* neon brand */
  ];

  var balls  = [];
  var width  = 0;
  var height = 0;
  var dpr    = Math.max(1, Math.min(2, window.devicePixelRatio || 1));

  var pointer = { x: -9999, y: -9999, active: false, grabbing: null, dragDX: 0, dragDY: 0, lastX: -9999, lastY: -9999 };

  var REPEL_RADIUS = 130;
  var REPEL_STRENGTH = 0.9;
  var FRICTION = 0.991;
  var MAX_SPEED = 14;

  function rand(min, max) { return Math.random() * (max - min) + min; }

  function resize() {
    var rect = canvas.getBoundingClientRect();
    width  = rect.width;
    height = rect.height;
    canvas.width  = Math.floor(width * dpr);
    canvas.height = Math.floor(height * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    if (balls.length === 0) initBalls();
    else clampBalls();
  }

  function initBalls() {
    balls.length = 0;
    var isSmall = Math.min(width, height) < 640;
    var count   = isSmall ? 7 : PALETTE.length;
    var minR    = isSmall ? 22 : 28;
    var maxR    = isSmall ? 34 : 46;
    for (var i = 0; i < count; i++) {
      var p = PALETTE[i % PALETTE.length];
      var r = rand(minR, maxR);
      var placed = false, attempts = 0, x = 0, y = 0;
      while (!placed && attempts < 80) {
        attempts++;
        x = rand(r + 20, width  - r - 20);
        y = rand(r + 20, height - r - 20);
        placed = true;
        for (var j = 0; j < balls.length; j++) {
          var b = balls[j];
          var dx = b.x - x, dy = b.y - y;
          if (dx * dx + dy * dy < (b.r + r + 10) * (b.r + r + 10)) { placed = false; break; }
        }
      }
      balls.push({
        x: x, y: y, r: r,
        vx: rand(-0.7, 0.7),
        vy: rand(-0.7, 0.7),
        main: p.main, dark: p.dark, num: p.num,
        rot: rand(0, Math.PI * 2)
      });
    }
  }

  function clampBalls() {
    for (var i = 0; i < balls.length; i++) {
      var b = balls[i];
      if (b.x < b.r) b.x = b.r;
      if (b.y < b.r) b.y = b.r;
      if (b.x > width  - b.r) b.x = width  - b.r;
      if (b.y > height - b.r) b.y = height - b.r;
    }
  }

  function update(dt) {
    var i, j, b;

    /* Grabbed ball follows pointer */
    if (pointer.grabbing) {
      var g = pointer.grabbing;
      var tx = pointer.x + pointer.dragDX;
      var ty = pointer.y + pointer.dragDY;
      g.vx = (tx - g.x) * 0.35;
      g.vy = (ty - g.y) * 0.35;
    }

    /* Pointer repulsion on non-grabbed balls */
    if (pointer.active && !pointer.grabbing) {
      for (i = 0; i < balls.length; i++) {
        b = balls[i];
        var dx = b.x - pointer.x;
        var dy = b.y - pointer.y;
        var dist2 = dx * dx + dy * dy;
        var R = REPEL_RADIUS + b.r;
        if (dist2 < R * R && dist2 > 0.01) {
          var dist = Math.sqrt(dist2);
          var force = (1 - dist / R) * REPEL_STRENGTH;
          b.vx += (dx / dist) * force;
          b.vy += (dy / dist) * force;
        }
      }
    }

    /* Integrate */
    for (i = 0; i < balls.length; i++) {
      b = balls[i];
      b.vx *= FRICTION;
      b.vy *= FRICTION;
      /* idle drift */
      if (Math.abs(b.vx) < 0.04 && Math.abs(b.vy) < 0.04) {
        b.vx += (Math.random() - 0.5) * 0.02;
        b.vy += (Math.random() - 0.5) * 0.02;
      }
      /* clamp speed */
      var sp = Math.sqrt(b.vx * b.vx + b.vy * b.vy);
      if (sp > MAX_SPEED) { b.vx = (b.vx / sp) * MAX_SPEED; b.vy = (b.vy / sp) * MAX_SPEED; }

      b.x += b.vx;
      b.y += b.vy;
      b.rot += (b.vx + b.vy) * 0.01;

      /* walls */
      if (b.x < b.r) { b.x = b.r; b.vx = -b.vx * 0.75; }
      if (b.y < b.r) { b.y = b.r; b.vy = -b.vy * 0.75; }
      if (b.x > width  - b.r) { b.x = width  - b.r; b.vx = -b.vx * 0.75; }
      if (b.y > height - b.r) { b.y = height - b.r; b.vy = -b.vy * 0.75; }
    }

    /* Ball-ball elastic collisions */
    for (i = 0; i < balls.length; i++) {
      for (j = i + 1; j < balls.length; j++) {
        var a = balls[i], c = balls[j];
        var ddx = c.x - a.x;
        var ddy = c.y - a.y;
        var d2  = ddx * ddx + ddy * ddy;
        var sr  = a.r + c.r;
        if (d2 < sr * sr && d2 > 0.0001) {
          var d  = Math.sqrt(d2);
          var nx = ddx / d;
          var ny = ddy / d;
          var overlap = sr - d;
          var push = overlap / 2;
          a.x -= nx * push;  a.y -= ny * push;
          c.x += nx * push;  c.y += ny * push;
          /* relative velocity along the normal */
          var vrx = c.vx - a.vx;
          var vry = c.vy - a.vy;
          var vn  = vrx * nx + vry * ny;
          if (vn < 0) {
            var imp = vn * 0.92;   /* slight energy loss */
            a.vx += nx * imp;  a.vy += ny * imp;
            c.vx -= nx * imp;  c.vy -= ny * imp;
          }
        }
      }
    }
  }

  function draw() {
    ctx.clearRect(0, 0, width, height);

    /* Soft connection lines between balls within range */
    ctx.lineWidth = 1;
    for (var i = 0; i < balls.length; i++) {
      for (var j = i + 1; j < balls.length; j++) {
        var a = balls[i], c = balls[j];
        var ddx = c.x - a.x;
        var ddy = c.y - a.y;
        var d   = Math.sqrt(ddx * ddx + ddy * ddy);
        if (d < 220) {
          var alpha = (1 - d / 220) * 0.09;
          ctx.strokeStyle = 'rgba(185, 255, 0,' + alpha.toFixed(3) + ')';
          ctx.beginPath();
          ctx.moveTo(a.x, a.y);
          ctx.lineTo(c.x, c.y);
          ctx.stroke();
        }
      }
    }

    /* Balls */
    for (var k = 0; k < balls.length; k++) drawBall(balls[k]);
  }

  function drawBall(b) {
    /* Glow halo */
    var glow = ctx.createRadialGradient(b.x, b.y, b.r * 0.9, b.x, b.y, b.r * 2.2);
    glow.addColorStop(0, hexToRgba(b.main, 0.28));
    glow.addColorStop(1, hexToRgba(b.main, 0));
    ctx.fillStyle = glow;
    ctx.beginPath();
    ctx.arc(b.x, b.y, b.r * 2.2, 0, Math.PI * 2);
    ctx.fill();

    /* Sphere body (radial gradient for 3D look) */
    var light = ctx.createRadialGradient(
      b.x - b.r * 0.35, b.y - b.r * 0.45, b.r * 0.1,
      b.x,              b.y,              b.r
    );
    light.addColorStop(0,   '#ffffff');
    light.addColorStop(0.1, lighten(b.main, 0.35));
    light.addColorStop(0.6, b.main);
    light.addColorStop(1,   b.dark);
    ctx.fillStyle = light;
    ctx.beginPath();
    ctx.arc(b.x, b.y, b.r, 0, Math.PI * 2);
    ctx.fill();

    /* Number circle (follows rotation for playful feel) */
    var nx = b.x + Math.cos(b.rot) * b.r * 0.12;
    var ny = b.y + Math.sin(b.rot) * b.r * 0.12;
    var nr = b.r * 0.42;

    ctx.save();
    var ring = ctx.createRadialGradient(nx - nr*0.2, ny - nr*0.2, nr*0.1, nx, ny, nr);
    ring.addColorStop(0, '#ffffff');
    ring.addColorStop(1, '#e8e8e8');
    ctx.fillStyle = ring;
    ctx.beginPath();
    ctx.arc(nx, ny, nr, 0, Math.PI * 2);
    ctx.fill();

    ctx.fillStyle = '#111';
    ctx.font = '900 ' + (nr * 1.1).toFixed(0) + 'px Archivo, system-ui, sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(String(b.num), nx, ny + nr * 0.06);
    ctx.restore();

    /* Specular highlight */
    var spec = ctx.createRadialGradient(
      b.x - b.r * 0.45, b.y - b.r * 0.55, 0,
      b.x - b.r * 0.45, b.y - b.r * 0.55, b.r * 0.5
    );
    spec.addColorStop(0, 'rgba(255,255,255,.55)');
    spec.addColorStop(1, 'rgba(255,255,255,0)');
    ctx.fillStyle = spec;
    ctx.beginPath();
    ctx.arc(b.x - b.r * 0.4, b.y - b.r * 0.5, b.r * 0.5, 0, Math.PI * 2);
    ctx.fill();
  }

  /* ── Color helpers ── */
  function hexToRgba(hex, a) {
    var h = hex.replace('#', '');
    if (h.length === 3) h = h.split('').map(function (ch) { return ch + ch; }).join('');
    var n = parseInt(h, 16);
    return 'rgba(' + ((n >> 16) & 255) + ',' + ((n >> 8) & 255) + ',' + (n & 255) + ',' + a + ')';
  }
  function lighten(hex, pct) {
    var h = hex.replace('#', '');
    if (h.length === 3) h = h.split('').map(function (ch) { return ch + ch; }).join('');
    var r = (parseInt(h, 16) >> 16) & 255;
    var g = (parseInt(h, 16) >> 8)  & 255;
    var b =  parseInt(h, 16)        & 255;
    r = Math.min(255, Math.round(r + (255 - r) * pct));
    g = Math.min(255, Math.round(g + (255 - g) * pct));
    b = Math.min(255, Math.round(b + (255 - b) * pct));
    return 'rgb(' + r + ',' + g + ',' + b + ')';
  }

  /* ── Pointer (mouse + touch unified) ── */
  function setPointer(e) {
    var rect = canvas.getBoundingClientRect();
    pointer.x = e.clientX - rect.left;
    pointer.y = e.clientY - rect.top;
  }

  function findBallAt(x, y) {
    /* iterate from top (last drawn) */
    for (var i = balls.length - 1; i >= 0; i--) {
      var b = balls[i];
      var dx = x - b.x, dy = y - b.y;
      if (dx * dx + dy * dy <= b.r * b.r) return b;
    }
    return null;
  }

  canvas.addEventListener('pointermove', function (e) {
    setPointer(e);
    pointer.active = true;
  });

  canvas.addEventListener('pointerdown', function (e) {
    setPointer(e);
    pointer.active = true;
    var hit = findBallAt(pointer.x, pointer.y);
    if (hit) {
      pointer.grabbing = hit;
      pointer.dragDX = hit.x - pointer.x;
      pointer.dragDY = hit.y - pointer.y;
      try { canvas.setPointerCapture(e.pointerId); } catch (err) {}
    } else {
      /* Click in empty space: push nearby balls outward */
      for (var i = 0; i < balls.length; i++) {
        var b = balls[i];
        var dx = b.x - pointer.x, dy = b.y - pointer.y;
        var d2 = dx * dx + dy * dy;
        if (d2 < 200 * 200 && d2 > 1) {
          var d = Math.sqrt(d2);
          var f = (1 - d / 200) * 9;
          b.vx += (dx / d) * f;
          b.vy += (dy / d) * f;
        }
      }
    }
  });

  canvas.addEventListener('pointerup', function (e) {
    if (pointer.grabbing) {
      /* Flick: add velocity based on recent pointer motion */
      var g = pointer.grabbing;
      var flickX = (pointer.x - pointer.lastX);
      var flickY = (pointer.y - pointer.lastY);
      g.vx = flickX * 0.9;
      g.vy = flickY * 0.9;
      try { canvas.releasePointerCapture(e.pointerId); } catch (err) {}
    }
    pointer.grabbing = null;
  });

  canvas.addEventListener('pointercancel', function () {
    pointer.grabbing = null;
    pointer.active   = false;
    pointer.x = pointer.y = -9999;
  });

  canvas.addEventListener('pointerleave', function () {
    pointer.active = false;
    pointer.x = pointer.y = -9999;
    pointer.grabbing = null;
  });

  /* Track last pointer for flick velocity */
  canvas.addEventListener('pointermove', function (e) {
    pointer.lastX = pointer.x;
    pointer.lastY = pointer.y;
    setPointer(e);
  });

  /* Prevent default touchmove so dragging doesn't scroll the page */
  canvas.addEventListener('touchmove', function (e) { e.preventDefault(); }, { passive: false });

  /* ── Resize observer ── */
  window.addEventListener('resize', resize);
  resize();

  /* ── Animation loop ── */
  var last = performance.now();
  function loop(now) {
    var dt = Math.min(40, now - last);
    last = now;
    update(dt);
    draw();
    requestAnimationFrame(loop);
  }
  requestAnimationFrame(loop);

  /* ── Respect reduced-motion: slow everything down ── */
  try {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      FRICTION = 0.97;
      MAX_SPEED = 4;
    }
  } catch (e) {}
})();
